var React = require('react');
var cx = require('classnames');

var CardForm = React.createClass({
    propTypes: {
        card: React.PropTypes.object,
        cvnOnly: React.PropTypes.bool,
        disabled: React.PropTypes.bool.isRequired,
        horizontal: React.PropTypes.arrayOf(React.PropTypes.number),
        handleUpdate: React.PropTypes.func,
        required: React.PropTypes.bool.isRequired,
        saveBg: React.PropTypes.bool,
        showNotice: React.PropTypes.bool,
        violations: React.PropTypes.array.isRequired
    },
    findViolationsForPath: function (path) {
        return this.props.violations.filter(function (violation) {
            return violation.property_path === path;
        });
    },
    getCard: function () {
        if (this.props.cvnOnly) {
            return {
                cvn: this.refs.cvn.getDOMNode().value,
                save: this.refs.save ? this.refs.save.getDOMNode().checked : null,
            };
        }

        return {
            cvn: this.refs.cvn.getDOMNode().value,
            expiryMonth: this.refs.expiryMonth.getDOMNode().value,
            expiryYear: this.refs.expiryYear.getDOMNode().value,
            name: this.refs.name.getDOMNode().value,
            number: this.refs.number.getDOMNode().value.replace(/[^0-9]+/g, ''),
            save: this.refs.save ? this.refs.save.getDOMNode().checked : null,
        };
    },
    getDefaultProps: function () {
        return {
            card: {},
            cvnOnly: false,
            disabled: false,
            horizontal: null,
            required: true,
            saveBg: false,
            showNotice: true,
            violations: []
        }
    },
    getField: function (path, ref, label, placeholder, value) {
        var violations = this.findViolationsForPath(path);
        var errors = violations.map(function (violation, i) {
            return <span key={i} className="help-block">{violation.message}</span>;
        });
        var classes = {
            "has-error": violations.length
        };
        var formClasses = this.getFormClasses();
        var card = this.props.card || {};
        if (!value) {
            value = function (ref, card) {
                return card[ref] || '';
            };
        }

        return <div key={ref} className={cx('form-group', classes)}>
            <label className={cx(formClasses.label)}>{label}</label>
            <div className={cx(formClasses.div)}>
            <input
                ref={ref}
                disabled={this.props.disabled}
                value={value(ref, card)}
                className={cx(formClasses.input)}
                type="text"
                placeholder={placeholder}
                onChange={this.handleUpdate}
            />
            {errors}
            </div>
        </div>;
    },
    getFormClasses: function () {
        var labelClasses = {
            "control-label": true,
            required: this.props.required
        };
        var divClasses = {};
        var inputClasses = {
            "form-control": true,
            "input-md": true
        };
        if (this.props.horizontal) {
            var horizontal = this.props.horizontal;
            if (!Array.isArray(this.props.horizontal)) {
                horizontal = [horizontal, 12-horizontal];
            }
            labelClasses["col-md-"+horizontal[0]] = true;
            divClasses["col-md-"+(horizontal[1])] = true;
        }

        return {
            label: labelClasses,
            div: divClasses,
            input: inputClasses
        };
    },
    handleUpdate: function (e) {
        this.props.handleUpdate && this.props.handleUpdate(this.getCard());
    },
    render: function () {
        var fields = [];

        if (!this.props.cvnOnly) {
            fields.push(this.getField('card.number', 'number', 'Card Number', 'XXXX XXXX XXXX XXXX', function (ref, card) {
                return ((card[ref] || '').match(/.{1,4}/g) || []).join(' ');
            }));
            fields.push(this.getField('card.name', 'name', 'Cardholder Name'));
            fields.push(this.getField('card.expiryMonth', 'expiryMonth', 'Expiry Month', 'MM'));
            fields.push(this.getField('card.expiryYear', 'expiryYear', 'Expiry Year', 'YYYY'));
        }
        fields.push(this.getField('card.cvn', 'cvn', 'CVN / CVV'));

        const formClasses = this.getFormClasses()

        return <section className="card-form">
            {fields}

          {this.props.saveBg && (
            <div className="form-group">
              <div className={cx(formClasses.label)} />
              <div className={cx(formClasses.div)}>
                <div className="checkbox">
                  <label>
                    <input
                      ref="save"
                      type="checkbox"
                      defaultChecked={true}
                    /> Save and use card for future payments
                  </label>
                </div>
                <span className="help-block">
                  Saving this card will set the card as preferred and it will be
                  used for all future automatic payments.
                </span>
              </div>
            </div>
          )}

            {this.props.showNotice && <div className="callout callout-warning">
                Charges for the Service are levied in advance on the Anniversary Date and
                on each Invoice Date thereafter. You will receive an electronic invoice
                via email (or paper invoice upon request) on the Invoice Date, which will
                provide you with the listed notice of the payment amount that will be
                taken out of your account on the Payment Date. All charges levied are
                to be paid by Credit Card (excluding Diners and American Express) and all
                payments are non-refundable.
            </div>}
        </section>;
    }
})
module.exports = CardForm;



// WEBPACK FOOTER //
// ./app/components/Payment/CardForm.js